import { hrBaseApi } from "app/services/HrBaseApi";

export const HrDashboardApis = hrBaseApi.injectEndpoints({
  endpoints: (builder) => ({

    /* ================= TODAY DASHBOARD COUNT ================= */
    TodayDashboardCountAPI: builder.query({
      query: ({ start_date, end_date }) => ({
        url: `/Felix/TodayDashboardCountAPI/`,
        method: "GET",
        params: {
          start_date,
          end_date,
        },
      }),
      providesTags: ["TodayDashboard"],
    }),

   /* ================= PENDING APPROVALS COUNT ================= */
PendingApprovalsCountAPI: builder.query({
  query: ({ start_date, end_date, company_id }) => ({
    url: `/Felix/PendingApprovalsCountAPI/`,
    method: "POST",
    body: {
      start_date,
      end_date,
      company_id,
    },
  }),
  providesTags: ["PendingApprovals"],
}),

/* ================= LATE REGULARIZATION ACTION ================= */
LateRegularizationActionAPI: builder.mutation({
  query: ({ employee_id, checkin_date, action }) => ({
    url: `/Felix/LateAttendanceRegularization/`,
    method: "POST",
    body: {
      employee_id,
      checkin_date,
      action, // APPROVE or REJECT
    },
  }),

  invalidatesTags: ["TodayDashboard", "PendingApprovals"],
}),

/* ================= TOTAL EMPLOYEES ================= */
TotalEmployeesAPI: builder.query({
  query: ({ start_date, end_date, company_id }) => ({
    url: `/Felix/TotalEmployees/`,
    method: "POST",
    body: {
      start_date,
      end_date,
      company_id,
    },
  }),
  providesTags: ["TotalEmployees"],
}),

/* ================= DEPARTMENT WISE ATTRITION RATE ================= */
DepartmentWiseAttritionRateAPI: builder.query({
  query: ({ start_date, end_date, company_id }) => ({
    url: `/Felix/DepartmentWiseAttritionRate/`,
    method: "POST",
    body: {
      start_date,
      end_date,
      company_id,
    },
  }),
  providesTags: ["DepartmentWiseAttrition"],
}),

/* ================= LEAVE USAGE TREND VIEW ================= */
LeaveUsageTrendViewAPI: builder.query({
  query: ({ start_date, end_date, company_id }) => ({
    url: `/Felix/LeaveUsageTrendView/`,
    method: "POST",
    body: {
      start_date,
      end_date,
      company_id,
    },
  }),
  providesTags: ["LeaveUsageTrend"],
}),

/* ================= LATE CHECKIN LIST VIEW ================= */
LateCheckinListAPIView: builder.query({
  query: ({ Company_Id, Date_From, Date_To, page = 1 }) => ({
    url: `/Felix/LateCheckinListAPIView/`,
    method: "POST",
    params: { page },       
    body: {
      Company_Id,
      Date_From,
      Date_To,
    },
  }),
  providesTags: ["LateCheckinList"],
}),


/* ================= PENDING LEAVE REQUESTS ================= */
PendingLeaveRequestsAPI: builder.query({
  query: ({ start_date, end_date, company_id }) => ({
    url: `/Felix/PendingLeaveRequests/`,
    method: "POST",
    body: {
      start_date,
      end_date,
      company_id,
    },
  }),
  providesTags: ["PendingLeaveRequests"],
}),

/* ================= EMPLOYEE CHECKIN SUMMARY ================= */
EmployeeCheckinSummaryAPI: builder.query({
  query: ({ start_date, end_date, company_id }) => ({
    url: `/Felix/EmployeeCheckinSummary/`,
    method: "POST",
    body: {
      start_date,
      end_date,
      company_id,
    },
  }),
  providesTags: ["EmployeeCheckinSummary"],
}),

/* ================= EMPLOYEE CHECKIN CRUD ================= */
EmployeecheckinCRUDAPI: builder.mutation({
  query: ({ id }) => ({
    url: `/Felix/EmployeecheckinCRUD/`,
    method: "PATCH",
    body: {
      id,
    },
  }),


  

  invalidatesTags: ["TodayDashboard", "PendingApprovals", "TotalEmployees"],
}),

  }),
});

/* ----- EXPORT HOOKS ----- */
export const {
  useTodayDashboardCountAPIQuery,
  usePendingApprovalsCountAPIQuery,
  useLateRegularizationActionAPIMutation,
  useEmployeecheckinCRUDAPIMutation,
  useTotalEmployeesAPIQuery,
  useDepartmentWiseAttritionRateAPIQuery,
  useLeaveUsageTrendViewAPIQuery,
  useLateCheckinListAPIViewQuery,
  usePendingLeaveRequestsAPIQuery,
  useEmployeeCheckinSummaryAPIQuery,
} = HrDashboardApis;
